import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GetAllStores,
  getPartListByCompanyFilter,
  GetopeningBal,
  AddOpeningBalance,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import AsyncSelectField from "../../components/AsyncSelectField";
import TextAreaField from "../../components/TextAreaField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const AddOpeningBal = () => {
  const navigate = useNavigate();
  const { storeG, userID } = useStateContext();
  const [partOptions, setPartOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [formData, setFormData] = useState({
    store: "Select Store",
    part: "Select Part",
    curr_stock: "-",
    min_stock: "0.0",
    max_stock: "0.0",
    balance: "0.0",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      if (e.name === "store")
        setFormData((prev) => ({
          ...prev,
          [e.name]: option,
          part: "select",
          curr_stock: "-",
          min_stock: "0.0",
          max_stock: "0.0",
          balance: "0.0",
          notes: "",
        }));
      else if (e.name === "part" && formData.store.value) {
        await GetopeningBal(option.value, formData.store.value)
          .then((resp) => {
            if (resp.success)
              setFormData((prev) => ({
                ...prev,
                [e.name]: option,
                curr_stock: resp.data.unit_instock.toFixed(2),
                min_stock: resp.data.min_stock.toFixed(2),
                max_stock: resp.data.max_stock.toFixed(2),
                balance: resp.data.opening_balance.toFixed(2),
              }));
            else
              setFormData((prev) => ({
                ...prev,
                [e.name]: option,
                curr_stock: "-",
                min_stock: "0.0",
                max_stock: "0.0",
                balance: "0.0",
                notes: "",
              }));
          })
          .catch((err) => console.log(err.message));
      }
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const loadOptions = async (inputText, callback) => {
    if (inputText.length > 2) {
      await getPartListByCompanyFilter(0, inputText)
        .then((resp) => {
          const partOptions = resp.data.map((item) => ({
            label: `${item.part_number} - ${item.description}`,
            value: item.part_id,
          }));
          setPartOptions(partOptions || []);
          callback(partOptions || []);
        })
        .catch((err) => console.log(err.message));
    } else callback(partOptions);
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Inventory");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    try {
      const response = await AddOpeningBalance(
        formData.store.value,
        formData.part.value,
        formData.min_stock,
        formData.max_stock,
        formData.balance,
        userID,
      );
      if (response.success) {
        showSuccessToast("Success!", "Part Inventory updated successfully!");
        navigate("/Inventory");
      } else
        showErrorToast(
          "Error!",
          "Part Inventory failed to update!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Part Inventory failed to update!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    function updateStore() {
      if (storeG?.store_id && storeOptions.length > 0) {
        setFormData((prev) => ({
          ...prev,
          store: { label: storeG.name, value: storeG.store_id },
        }));
      }
    }
    updateStore();
  }, [storeOptions, storeG]);

  useEffect(() => {
    async function fetchData() {
      TimeoutUtility.resetTimeout();
      await GetAllStores()
        .then((resp) => {
          const storeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.store_id,
          }));
          setStoreOptions(storeOptions || []);
        })
        .catch((err) => console.log(err.message));
    }
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ADD PART TO STORE" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <SelectField
                  label="Store:"
                  name="store"
                  value={formData.store}
                  options={storeOptions}
                  onChange={handleSelectChange}
                  placeholder="Store"
                  compulsory={true}
                  error={errors.store}
                />
                <AsyncSelectField
                  label="Part:"
                  name="part"
                  value={formData.part}
                  loadOptions={loadOptions}
                  // options={partOptions}
                  onChange={handleSelectChange}
                  placeholder="Part"
                  compulsory={true}
                  error={errors.part}
                  autoFocus
                />
                <TextAreaField
                  label="Notes:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
              </div>
            </Col>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Current Balance:"
                  name="curr_stock"
                  value={formData.curr_stock}
                  placeholder="Current Balance"
                  disabled
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  onChange={handleChange}
                  placeholder="Opening Balance"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.balance}
                />
                <DoubleField
                  label="Min Stock:"
                  name="min_stock"
                  value={formData.min_stock}
                  onChange={handleChange}
                  placeholder="Min Stock"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.min_stock}
                />
                <DoubleField
                  label="Max Stock:"
                  name="max_stock"
                  value={formData.max_stock}
                  onChange={handleChange}
                  placeholder="Max Stock"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.max_stock}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddOpeningBal;
